import { useEffect, useState } from "react";
import { Circle } from "lucide-react";
import { api } from "@/lib/api";

/**
 * Live-/slutresultat-rad för dashboard-events.
 *
 * - Pågående match → "🔴 LIVE: 0 - 0" (röd pulserande prick, svart text)
 * - Slutförd match → "RESULTAT: 8 - 12" (svart text)
 * - Ej startad/inte registrerad → renderar inget
 *
 * Block-element, samma textstorlek som metadata-raden ovanför ("text-xs"),
 * svart färg så det syns tydligt på cream-bakgrunden. Pollar var 60:e sek.
 */
export function FootballInlineScore({ eventId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let timer;
    const load = async () => {
      try {
        const r = await api.get(`/events/${eventId}/minfotboll/status`);
        if (!cancelled) setData(r.data);
      } catch (_e) {
        /* nät-fel — behåll förra state */
      }
    };
    load();
    timer = setInterval(load, 60_000);
    return () => {
      cancelled = true;
      if (timer) clearInterval(timer);
    };
  }, [eventId]);

  if (!data?.registered || !data.header) return null;
  const h = data.header;
  const status = h.status_id;
  const isLive = status === 2;
  const isFinished = status === 3;
  const score = `${h.home_score ?? "0"} - ${h.away_score ?? "0"}`;

  if (isLive) {
    return (
      <p
        className="mt-1 flex items-center gap-1.5 text-xs font-semibold tabular-nums text-[color:var(--text-primary)]"
        data-testid="football-inline-live"
      >
        <Circle size={9} fill="#DC2626" className="text-[#DC2626] animate-pulse" />
        <span>LIVE: {score}</span>
      </p>
    );
  }
  if (isFinished) {
    return (
      <p
        className="mt-1 text-xs font-semibold tabular-nums text-[color:var(--text-primary)]"
        data-testid="football-inline-final"
      >
        RESULTAT: {score}
      </p>
    );
  }
  return null;
}
